import { styled, AccordionPanel } from '@grupoboticario/flora-react';

const styles = {
  AccordionPanel: styled(AccordionPanel, {
    lineHeight: '$bodyMediumShort',
    marginBottom: '$4',
    'li:first-of-type': {
      padding: '0',
    },
  }),
};

export default styles;
